import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SettingsPage } from './settings.page';
import { AuthGuard } from '../services/user/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: SettingsPage,
    canActivate: [AuthGuard]
  },
  {
    path: 'salon-profile',
    loadChildren: () => import('./salon-profile/salon-profile.module').then( m => m.SalonProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'stylist-manager',
    loadChildren: () => import('./stylist-manager/stylist-manager.module').then( m => m.StylistManagerPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'stylist-profile/:id',
    loadChildren: () => import('./stylist-profile/stylist-profile.module').then( m => m.StylistProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'site-settings',
    loadChildren: () => import('./site-settings/site-settings.module').then( m => m.SiteSettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'booking-settings',
    loadChildren: () => import('./booking-settings/booking-settings.module').then( m => m.BookingSettingsPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'pos-settings',
    loadChildren: () => import('./pos-settings/pos-settings.module').then( m => m.PosSettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'work-day-settings/work-day-list',
    loadChildren: () => import('./work-day-settings/work-day-list/work-day-list.module').then( m => m.WorkDayListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'social-media-settings',
    loadChildren: () => import('./social-media-settings/social-media-settings.module').then( m => m.SocialMediaSettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'services/manager',
    loadChildren: () => import('./service-settings/service-manager/service-manager.module').then( m => m.ServiceManagerPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'notification-settings',
    loadChildren: () => import('./notification-settings/notification-settings.module').then( m => m.NotificationSettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'commission-settings',
    loadChildren: () => import('./commission-settings/commission-settings.module').then( m => m.CommissionSettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'custom-email-settings',
    loadChildren: () => import('./custom-email-settings/custom-email-settings.module').then( m => m.CustomEmailSettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then( m => m.AboutPageModule)
  },
  {
    path: 'stylist-create',
    loadChildren: () => import('./stylist-create/stylist-create.module').then( m => m.StylistCreatePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'payment-processing-settings',
    loadChildren: () => import('./payment-processing-settings/payment-processing-settings.module').then( m => m.PaymentProcessingSettingsPageModule),
    canActivate: [AuthGuard]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsPageRoutingModule {}
